import React from 'react';

// import GitHubIcon from '@mui/icons-material/GitHub';
// import LinkedInIcon from '@mui/icons-material/LinkedIn';
// import FacebookIcon from '@mui/icons-material/Facebook';

import { BsLinkedin } from 'react-icons/bs';
import { FaGithub } from 'react-icons/fa';
import { BsFacebook } from 'react-icons/bs';

const HeaderSocials = () => {
  return (
    <div className="header__socials">
      <a href="https://github.com/TomK02" target="__blank">
        <FaGithub />
      </a>
      <a
        href="https://www.linkedin.com/in/tomio-koshikawa-5585ba210/"
        target="__blank"
      >
        <BsLinkedin />
      </a>
      <a href="https://www.facebook.com/tvk02jr/" target="__blank">
        <BsFacebook />
      </a>
    </div>
  );
};

export default HeaderSocials;
